import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';
import Toggle from 'react-toggle';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class UsersEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      staff_list: [],
      data_base: [],
      data_groups: [],
      name: '',
      email: '',
      id: '',
      client: 0,
      exam: 0,
      exam_instructor: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.editGroups = this.editGroups.bind(this);
    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // Handlers
  handleCheckboxChangeGroups (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.data_groups).map(function(k) {
      if(self.state.data_groups[k].id === name) {
        change = {
          checked: event.target.checked,
          group: self.state.data_groups[k].group,
          id: self.state.data_groups[k].id,
        };

      } else {
        change = {
          checked: self.state.data_groups[k].checked,
          group: self.state.data_groups[k].group,
          id: self.state.data_groups[k].id,
        };
      }
      data_temp.push(change);
    });
    this.setState({data_groups: data_temp});
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/usuario/grupos/permissao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_groups: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/usuario/editar/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            email: responseJson.data.email,
            staff_id: responseJson.data.staff_id,
            client: responseJson.data.client,
            exam: responseJson.data.exam,
            exam_instructor: responseJson.data.exam_instructor,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Lista de funcionários */ }); /* Dados do usuário */
    });
  }

  // Fetch salvando a edição
  editGroups(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      data: this.state.data_groups,
      user_id: this.props.match.params.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario/grupos/permissao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_groups: responseJson.data});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      client: this.state.client,
      exam: this.state.exam,
      exam_instructor: this.state.exam_instructor,
      email: this.state.email,
      staff_id: this.state.staff_id,
      name: this.state.name,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            staff_name: responseJson.data.staff_name,
            staff_id: responseJson.data.staff_id,
            email: responseJson.data.email,
            client: responseJson.data.client,
            exam: responseJson.data.exam,
            exam_instructor: responseJson.data.exam_instructor,
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar usuário</h3>
      <Link to="/usuarios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nome:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>E-mail:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Funcionário:</label>
            <Select
              className=""
              name="staff_id"
              value={this.state.staff_id}
              searchable={true}
              placeholder={'Selecionar base'}
              onChange={this.handleSelectChange.bind(this, 'staff_id')}
              options={this.state.staff_list}
            />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em provas?:</label>
              <br/>
              <Toggle
                checked={this.state.client}
                aria-label='No label tag'
                name="client"
                onChange={this.handleToggleChange.bind(this, 'client')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
              <label>Usado em provas?:</label>
              <br/>
              <Toggle
                checked={this.state.exam}
                aria-label='No label tag'
                name="exam"
                onChange={this.handleToggleChange.bind(this, 'exam')} />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em examinador de provas?:</label>
              <br/>
              <Toggle
                checked={this.state.exam_instructor}
                aria-label='No label tag'
                name="exam_instructor"
                onChange={this.handleToggleChange.bind(this, 'exam_instructor')} />
          </div>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">Grupos de permissões</h3>
      <hr/>
      <form onSubmit={this.editGroups}>
        <div className="row">
          {Object.keys(self.state.data_groups).map(function(k) {
            return (
              <div className="col-md-3 col-md-offset-1">
                <div className="form-group">
                  <label>
                    <input
                      name="checkbox"
                      label={self.state.data_groups[k].group}
                      type="checkbox"
                      checked={self.state.data_groups[k].checked}
                      onChange={self.handleCheckboxChangeGroups.bind(self, self.state.data_groups[k].id)} />
                    {self.state.data_groups[k].group}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default UsersEdit;



// WEBPACK FOOTER //
// ./src/Components/Users/UsersEdit.js